module.exports = __webpack_public_path__ + "static/media/icon-geolocation.15b3dd4c.svg";